import { useMemo } from 'react'
import { ResetPasswordOutcome } from '@/screens/reset-password/ResetPasswordOutcome'
import { pickLink, readResultLinks } from '@/screens/reset-password/resultLinks'
import locales from '@/screens/reset-password/locales/pt-BR.json'

/**
 * S8 — tela `reset-password-success` do Auth0, depois de salvar a nova senha.
 * O botão só aparece quando o Auth0 manda o caminho de volta; sem ele, a
 * mensagem diz ao usuário onde entrar.
 */
export default function ResetPasswordSuccessScreen() {
  const { inUniversalLogin, links } = useMemo(readResultLinks, [])
  const target = inUniversalLogin
    ? pickLink(links, /login|back|continue/i)
    : '?screen=login-id'

  return (
    <ResetPasswordOutcome
      tone="positive"
      title={locales.successTitle}
      message={locales.success}
      action={
        target
          ? { label: locales.goToLogin, onClick: () => window.location.assign(target) }
          : undefined
      }
      hint={locales.successHint}
    />
  )
}
